import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_NEW_CLIENT,
  BULK_UPLOAD,
  UPDATE_NEW_CLIENT,
  CLIENT_DATA,
  DELETE_CLIENT_BYID,
  CLIENT_DROP
} from "./actiontype";
import {
  onAddnewClientSuccess,
  togglePageLoader,
  onAddnewClientError,
  clientListSuccess,
  clientListError,
  onDeleteclientSuccess,
  onDeleteclientError,
  onupdateClientSuccess,
  onupdateUserError,
  onupdateClientError,
  dropdownclientListSuccess
} from "../actions";

import {getAllClients,postAddClient,patchUpdateClient,deleteClientById}  from "../../helpers/api";
import toast from "toastr";
import { notifications } from "@mantine/notifications";
//import { DELETE_CLIENT_BYID } from "@/helpers/url_helper";

function* getClientsList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getAllClients, params, exportname);

    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(clientListSuccess(response));
        yield put(togglePageLoader(false));
      } else {
        yield put(clientListError(response));
        toast.error(response.message);
        yield put(togglePageLoader(false));
      }
     } 
     else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* createnewclient({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true));
    const reqFormData = new FormData();

      const logoFileName = params.logoFileUpload;
      reqFormData.append("id", params.clientData?.id || 0); 
      reqFormData.append("name", params.name);

      if (logoFileName) {
        reqFormData.append("logoFileUpload", logoFileName);
      }      
     const response = yield call(postAddClient, reqFormData);
    if (response && response.message !=="Client name already exists.") {
      yield put(onAddnewClientSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("ADD SUCCESS");
    } else {
      yield put(onAddnewClientError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
      callback("ADD FAILURE");
    }

  } catch (error) {
    yield put(onAddnewClientError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* updatenewClient({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true));
    const reqFormData = new FormData();
    const logoFileName = data.logoFileUpload;
    reqFormData.append("id", data.id);
    reqFormData.append("name", data.name);
    if (logoFileName) {
      reqFormData.append("logoFileUpload", data.logoFileUpload);
    }
    const response = yield call(patchUpdateClient, reqFormData);
    if (response && response.message !=="Client name already exists.") {
      yield put(onupdateClientSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("SUCCESS");
    } else {
      yield put(onupdateClientError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onupdateClientError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}


function* deleteClient({ payload: userId,callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(deleteClientById, userId);

   if (response) {
      yield put(onDeleteclientSuccess(userId));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("SUCCESS");
    } else {
      yield put(onDeleteclientError(response));
      toast.error(response.message);
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onDeleteclientError(error));
    toast.error(error?.response ? error.response.data.message : error.message);
  } finally {
    yield put(togglePageLoader(false));
  }
}

// function* bulkupload({ payload: data, callback }) {
//   try {
//     yield put(togglePageLoader(true));
//     const response = yield call(update_bulk_upload, data);
//     if (response.statusCode === 200) {
//       yield put(postuploadDataSuccess(response));
//       yield put(togglePageLoader(false));
//       toast.success(response.message);
//       callback("SUCCESS");
//     } else {
//       yield put(postuploadDataError(response));
//       toast.error(response.message);
//       yield putglePageLoader(false);
//       callback("FAILURE");
//     }
//   } catch (error) {
//     yield put(postuploadDataError(error));
//     toast.error(error?.response ? error.response?.data?.message : error);
//     yield put(togglePageLoader(false));
//   }
// }
function* getClientNameDropDownList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getAllClients, params, exportname);
    if (exports !== "export") {
      if (response.statusCode === 200) {    
          yield put(dropdownclientListSuccess(response));
        yield put(togglePageLoader(false));
      } else {
        yield put(clientListError(response));
        toast.error(response.message);  
      }
     } 
     else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* clientlist() {
  yield takeEvery(CLIENT_DATA, getClientsList);
  yield takeEvery(ADD_NEW_CLIENT, createnewclient);
  yield takeEvery(UPDATE_NEW_CLIENT, updatenewClient);
  yield takeEvery(DELETE_CLIENT_BYID, deleteClient);
  
  yield takeEvery(CLIENT_DROP, getClientNameDropDownList);
  //yield takeEvery(BULK_UPLOAD, bulkupload);
}

export default clientlist;
